export default __webpack_public_path__ + "static/media/map.509e80ce.png";